// Pure helpers for the K-News attention flow (bubble hop + preview card +
// reader modal). Kept dependency-free so they can be unit-tested without a
// component harness.

// The broadcast to surface in the preview card: newest unread, or nothing.
export function firstUnread(items) {
  return (items || []).find((b) => b && !b.is_read) || null;
}

// Plain-text teaser for list cards + the preview card. `body` is raw Markdown
// or pasted HTML and `body_html` is the server-sanitised render, so strip
// tags and Markdown markers from whichever we have and decode entities.
export function newsSnippet(bc, max = 160) {
  const src = (bc && (bc.body_html || bc.body)) || "";
  const s = src
    .replace(/<[^>]+>/g, " ")
    .replace(/^\s*#{1,6}\s+/gm, "")
    .replace(/^\s*(?:[-*]|\d+\.)\s+/gm, "")
    .replace(/(\*\*|__|`|\*|_)/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, " ")
    .trim();
  return s.length > max ? `${s.slice(0, max - 1).trimEnd()}…` : s;
}

// Prev/next inside the reader modal. dir = -1 (newer) | +1 (older), following
// list order (API returns newest first). Returns null at either end.
export function siblingBroadcast(items, currentId, dir) {
  const list = items || [];
  const i = list.findIndex((b) => b && b.id === currentId);
  if (i === -1) return null;
  return list[i + dir] || null;
}
